import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const hepAdapter = createEntityAdapter({})

const initialState = hepAdapter.getInitialState()

export const hepexercisesApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getHepExercises: builder.query({
            query: () => ({
                url: '/hep/exercises/',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedHep = responseData.map(hep => {
                    hep.id = hep._id
                    return hep
                });
                return hepAdapter.setAll(initialState, loadedHep)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'HepExercise', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'HepExercise', id }))
                    ]
                } else return [{ type: 'HepExercise', id: 'LIST' }]
            }
        }),
        updateSortExercises: builder.mutation({
            query: ({ exercises }) => ({
                url: `/hep/exercises/sort`,
                method: 'POST',
                body: {exercises}
            }),
            invalidatesTags: [
                { type: 'HepExercise', id: "LIST" }
            ]
        }),
        addNewHepExercise: builder.mutation({
            query: initialExerciseData => ({
                url: '/hep/exercises',
                method: 'POST',
                body: {
                    ...initialExerciseData,
                }
            }),
            invalidatesTags: [
                { type: 'HepExercise', id: "LIST" }
            ]
        }),
        updateHepExercise: builder.mutation({
            query: initialExerciseData => ({
                url: '/hep/exercises',
                method: 'PATCH',
                body: {
                    ...initialExerciseData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'HepExercise', id: arg.id }
            ]
        }),
        deleteHepExercise: builder.mutation({
            query: ({ id }) => ({
                url: `/hep/exercises`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'HepExercise', id: arg.id }
            ]
        }),

    }),
})

export const {
    useGetHepExercisesQuery,
    useUpdateSortExercisesMutation,
    useAddNewHepExerciseMutation,
    useUpdateHepExerciseMutation,
    useDeleteHepExerciseMutation,

} = hepexercisesApiSlice

// returns the query result object
export const selectHepExercisesResult = hepexercisesApiSlice.endpoints.getHepExercises.select()

// creates memoized selector
const selectHepExercisesData = createSelector(
    selectHepExercisesResult,
    HepExercisesResult => HepExercisesResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllHepExercises,
    // Pass in a selector that returns the notes slice of state
} = hepAdapter.getSelectors(state => selectHepExercisesData(state) ?? initialState)